import { ID, lAsync } from 'app/blocks/common/codes';
import Emitter from 'app/blocks/common/events/emitter';
import Events from 'app/blocks/common/events/Events';
import showDialog from 'app/blocks/common/jsx/dialogModal';
import Alerts from 'app/blocks/common/spinner';
import * as Utils from 'app/blocks/common/utils';
import * as middlewareOrcid from 'app/blocks/middleware/orcid';
import * as middlewareProfile from 'app/blocks/middleware/profile';
import ProfileSections from 'app/pages/profile/model/profile-sections';

const V = Utils.validation;

export async function saveProfileInformation(data) {
    try {
        Alerts.renderSpinner();
        await middlewareProfile.saveProfileInformation(data);
        showDialog.success({
            message: await lAsync(
                'PROFILE_ACCOUNT.confirmationMessages.PROFILE_ACCNT_PROFILE_INFO_SAVE_POST_CONF_TEXT',
            ),
        });
    } finally {
        Alerts.removeSpinner();
    }
}

export async function updateOrcid(orcidCode) {
    const data = await middlewareOrcid.getData(orcidCode, false);
    const { orcidId } = data.user;
    await middlewareProfile.saveProfileInformation({ orcidId });
    Emitter.emit(Events.PROFILE_INFORMATION_SAVED, { orcidId });
}

export async function saveOrcidProfileInformation(data) {
    try {
        Alerts.renderSpinner();
        await middlewareProfile.saveProfileInformation(data);
        const message = await lAsync(
            'PROFILE_ACCOUNT.confirmationMessages.PROFILE_ACCNT_PROFILE_INFO_SAVE_POST_CONF_TEXT',
        );
        Emitter.emit(Events.PROFILE_DATA_FILLED, ProfileSections.ORCID);
        return new Promise(resolve => showDialog.success({ message, onClose: resolve }));
    } finally {
        Alerts.removeSpinner();
    }
}

export function validateProfileInformation(firstName, middleName, lastName, countryCode) {
    const ERROR_PREFIX = `${ID.PROFILE_ACCOUNT}.errorMessages`;
    const isLatinOrEmpty = val => !val || V.validateInputConstrainedLatinExtendedChars(val);

    return {
        firstName: V.validate(firstName, [
            [V.notEmpty, `${ERROR_PREFIX}.PROFILE_ACCNT_FIRST_NAME_MISSING_DATA_ERR_TEXT`],
            [
                V.validateInputConstrainedLatinExtendedChars,
                `${ERROR_PREFIX}.PROFILE_ACCNT_FIRST_NAME_INVALID_DATA_ERR_TEXT`,
            ],
        ]),
        middleName: V.validate(middleName, [
            [isLatinOrEmpty, `${ERROR_PREFIX}.PROFILE_ACCNT_MIDDLE_NAME_INVALID_DATA_ERR_TEXT`],
        ]),
        lastName: V.validate(lastName, [
            [V.notEmpty, `${ERROR_PREFIX}.PROFILE_ACCNT_LAST_NAME_MISSING_DATA_ERR_TEXT`],
            [
                V.validateInputConstrainedLatinExtendedChars,
                `${ERROR_PREFIX}.PROFILE_ACCNT_LAST_NAME_INVALID_DATA_ERR_TEXT`,
            ],
        ]),
        country: V.validate(countryCode, [[V.notEmpty, `${ERROR_PREFIX}.PROFILE_ACCNT_COUNTRY_MISSING_DATA_ERR_TEXT`]]),
    };
}
